export default __webpack_public_path__ + "static/heart-frame-01-81c583af71071c002500bcd92377bf05.png";